module.exports = __webpack_public_path__ + "static/media/2020.9.18 老年人关怀服务 老年出厨房.9b744cdd.jpg";